var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDestination({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20V16H4V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6V14H18V4ZM4 2V16H20V2H4Z",
    fill: "#2F2F32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V22H4V2Z",
    fill: "#4D65F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5H8V7H10V9H8V11H10V13H12V11H14V13H16V11H14V9H16V7H14V5H12V7H10V5ZM12 9H14V7H12V9ZM12 9H10V11H12V9Z",
    fill: "#2F2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDestination);
export default __webpack_public_path__ + "static/media/list_destination.5d5c1126ecf17b23afc2fb1c05d372fa.svg";
export { ForwardRef as ReactComponent };